<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-cc-vscroll-table #ccTable [transPartKey]="transPartKey"
                      [tableConfig]="tableConfig"
                      [headerButtonConfig]="headerButtonConfig"
                      [contextMenuConfig]="tableContextMenuConfig"
                      [records]="records"
                      [recordIds]="recordIds"
                      [(selectedIds)]="selectedIds"
                      (selectedIdsChange)="refreshSelectionInfos(); selectedIdsChange.emit($event); "
                      [totalRecords]="totalRecords" [loading]="tableLoadingCount>0"
                      [currentRequest]="tableCurrentRequest"
                      (loadRecordsEvent)="loadRecords($event)"
                      [fieldName]="'id'" [fieldId]="'id'" [scrollHeightNumber]="scrollHeight"
                      [defaultSortField]="tableConfigService.defaultSortField" [defaultSortOrder]="tableConfigService.defaultSortOrder"
                      (onRowDblClick)="rowDblClick($event)"
                      (onCtrlShift)="ctrlShift($event)"
                      (onShift_S)="rowDblClick($event)"
                      (filterChangedEvent)="filterSortChanged()" (sortChangedEvent)="filterSortChanged()"
                      (onColOrderChange)="colOrderChanged($event)"
>
  <span caption-left-left pButton class="p-button-text p-button-sm header-button"
          [icon]="'fa fa-bars'"
          (click)="activeChanged()" pTooltip="{{'page.' + this.transPartKey + '.table.'+
          'show_trades' | translate}}"></span>
  <span caption-left class="ignore-filter-selection-header">
    <i class="toolbar-separator fa fa-diamond">
    </i>
    <span class="m-0-5">{{'page.clearing.trade.selection.filters.ignore'|translate}}</span>
    <p-multiSelect #multOver [options]="filterWithValuesOptions"
                   [(ngModel)]="filterWithValue"
                   optionLabel="text" display="chip"
                   [optionValue]="'id'" appendTo="app-main-layout"
                   filterBy="text"
                   [showHeader]="true"
                   (onChange)="filterChanged($event.value, multOver)"
                   [virtualScroll]="false" virtualScrollItemSize="10"
                   [disabled]="tableLoadingCount>0" [optionDisabled]="tableLoadingCount>0?'disabled':'none'"
    >
    </p-multiSelect>
    <button type="button" pRipple pButton class="clear-filter p-button-warning p-button p-button-icon-only"
            [icon]="'fas fa-xmark'" (click)="clearFilter()"
            [disabled]="tableLoadingCount>0||!filterWithValue||filterWithValue.length==0"></button>

  </span>
  <!--  (onContextMenuShow)="refreshContextMenu()"-->
  <button *ngIf="maximizable" caption-right pButton class="p-button-text p-button-sm header-button"
          [icon]="'fa fa-'+(maximized?'compress':'expand')"
          (click)="maximize()" pTooltip="{{'common.'+(maximized?'minimize':'maximize') | translate}}"
          tooltipPosition="left"></button>

  <span
    footer-left>{{('common.lastUpdated'|translate) + ': ' + (lastUpdated ? (lastUpdated|date:'HH:mm:ss') : '')}}</span>

  <app-clearing-selection-summary footer-right [isDark]="true"
                                  [summaryBuyValue]="summaryBuyValue"
                                  [summarySellValue]="summarySellValue"></app-clearing-selection-summary>

  <p-progressSpinner footer-right class="cc-spinner-sm" *ngIf="isSelectionInfoLoading" strokeWidth="5"
                     fill="var(--surface-ground)" animationDuration="0.8s"></p-progressSpinner>
</app-cc-vscroll-table>
<!--defaultSortFieldName="creationDate"-->
<app-clearing-trade-detail #tradeDetailDialog></app-clearing-trade-detail>
<app-clearing-single-allocation-form #singleAllocationDialog
                                     (onSavedForm)="onSingleAllocationSubmit($event)"></app-clearing-single-allocation-form>
<app-clearing-single-allocation-multi-exchange-form #singleAllocationMultiExchangeDialog
                                                    (onSavedForm)="onSingleAllocationMultiExchangeSubmit($event)"></app-clearing-single-allocation-multi-exchange-form>
<app-clearing-split-allocation-form #splitAllocationDialog
                                    (onSavedForm)="onSplitAllocationSubmit($event)"></app-clearing-split-allocation-form>
<app-clearing-override-custom-reference-form #overrideCustomReferenceDialog
                                             (onSavedForm)="onUpdateTradePrice($event)"></app-clearing-override-custom-reference-form>
<app-clearing-update-trade-price-form #updateTradePriceDialog
                                      (onSavedForm)="onUpdateTradePrice($event)"></app-clearing-update-trade-price-form>
<app-clearing-create-order-form #createOrderDialog
                                (onSavedForm)="onCreateOrder($event)"></app-clearing-create-order-form>
<app-clearing-select-table-columns-form #selectTableColumnsDialog
                                        (onSavedForm)="onSelectTableColumns($event)"></app-clearing-select-table-columns-form>
